// LEGACY MIGRATION (temporary) — remove with pages/LegacyMigration.
import { getLegacyMigrationMessages } from "@pages/LegacyMigration/languages";
import {
  TranslationConfirmAccountMessages,
  TranslationDataTableMessages,
  TranslationFilterMessages,
  TranslationGlobalMessages,
  TranslationLoginMessages,
  TranslationMaintenanceUserMessages,
  TranslationUserFormMessages,
  TranslationYupMessages,
  TranslationUserRightsMessages,
  TranslationRoleRegisterMessages,
  TranslationRoleFormMessages,
  TranslationFormUserMessages,
  TranslationUserRegisterMessages,
  TranslationCustomClaimMessages,
  TranslationExpiredSessionMessages,
  TranslationTenantSelectionMessages,
  TranslationClaimMessages,
  TranslationClaimGroupMessages,
  TranslationPermissionGroupMessages,
  TranslationLauncherMessages,
  TranslationAnnouncementMessages
} from "./interfaces";

interface TranslationData extends TranslationLoginMessages, TranslationConfirmAccountMessages,
  TranslationYupMessages, TranslationUserFormMessages, TranslationDataTableMessages,
  TranslationGlobalMessages, TranslationFilterMessages, TranslationMaintenanceUserMessages,
  TranslationUserRightsMessages, TranslationRoleRegisterMessages, TranslationUserRegisterMessages,
  TranslationFormUserMessages, TranslationRoleFormMessages, TranslationCustomClaimMessages,
  TranslationExpiredSessionMessages, TranslationTenantSelectionMessages, TranslationClaimMessages,
  TranslationClaimGroupMessages, TranslationPermissionGroupMessages, TranslationLauncherMessages,
  TranslationAnnouncementMessages {}

export interface LanguageData {translation: TranslationData;}

export type TLanguages = "pt-BR" | "en-US" | "es";

interface ILanguage {
  language: TLanguages;
  description: string;
}

export const languages: ILanguage[] = [
  {
    language: "en-US",
    description: "English"
  },
  {
    language: "pt-BR",
    description: "Português"
  },
  {
    language: "es",
    description: "Español"
  }
];

/**
 * Use this function to get the language data from the language code
 * @param language
 * @param fileName
 * @returns
 */
const getMessages = (language: TLanguages, fileName: string) => {
  const data = require(`./${language}/${fileName}.ts`);

  return data.messages;
};

export function getLanguageData(language: TLanguages) {

  const loginMessages = getMessages(language, "loginMessages") as TranslationLoginMessages;
  const resetPasswordMessages = getMessages(language, "confirmAccountMessages") as TranslationConfirmAccountMessages;
  const yupMessages = getMessages(language, "yupMessages") as TranslationYupMessages;
  const userFormMessages = getMessages(language, "userFormMessages") as TranslationUserFormMessages;
  const dataTableMessages = getMessages(language, "dataTableMessages") as TranslationDataTableMessages;
  const globalMessages = getMessages(language, "globalMessages") as TranslationGlobalMessages;
  const filterMessages = getMessages(language, "filterMessages") as TranslationFilterMessages;
  const maintenanceUserMessages = getMessages(language, "maintenanceUserMessages") as TranslationMaintenanceUserMessages;
  const userRightsMessages = getMessages(language, "userRightsMessages") as TranslationUserRightsMessages;
  const tenantSelectionMessages = getMessages(language, "tenantSelectionMessages") as TranslationTenantSelectionMessages;
  const roleRegisterMessages = getMessages(language, "roleRegisterMessages") as TranslationRoleRegisterMessages;
  const userRegisterMessages = getMessages(language, "userRegisterMessages") as TranslationUserRegisterMessages;
  const formUserMessages = getMessages(language, "formUserMessages") as TranslationFormUserMessages;
  const roleFormMessages = getMessages(language, "roleFormMessages") as TranslationRoleFormMessages;
  const customClaimMessages = getMessages(language, "customClaimMessages") as TranslationCustomClaimMessages;
  const expiredSessionMessages = getMessages(language, "expiredSessionMessages") as TranslationExpiredSessionMessages;
  const claimMessages = getMessages(language, "claimMessages") as TranslationClaimMessages;
  const claimGroupMessages = getMessages(language, "claimGroupMessages") as TranslationClaimGroupMessages;
  const permissionGroupMessages = getMessages(language, "permissionGroupMessages") as TranslationPermissionGroupMessages;
  const launcherMessages = getMessages(language, "launcherMessages") as TranslationLauncherMessages;
  const announcementMessages = getMessages(language, "announcementMessages") as TranslationAnnouncementMessages;

  // LEGACY MIGRATION (temporary)
  const legacyMigrationMessages = getLegacyMigrationMessages(language);

  const languageData: LanguageData = {
    translation: {
      ...loginMessages,
      ...resetPasswordMessages,
      ...yupMessages,
      ...userFormMessages,
      ...dataTableMessages,
      ...globalMessages,
      ...filterMessages,
      ...maintenanceUserMessages,
      ...userRightsMessages,
      ...roleRegisterMessages,
      ...userRegisterMessages,
      ...formUserMessages,
      ...roleFormMessages,
      ...customClaimMessages,
      ...expiredSessionMessages,
      ...tenantSelectionMessages,
      ...claimMessages,
      ...claimGroupMessages,
      ...permissionGroupMessages,
      ...launcherMessages,
      ...announcementMessages,

      // LEGACY MIGRATION (temporary)
      ...legacyMigrationMessages
    }
  };

  return languageData;
}
